/*
 * @Author: louzhedong
 * @Date: 2020-09-10 11:08:08
 * @LastEditors: louzhedong
 * @LastEditTime: 2020-09-28 14:22:31
 * @Description: 
 */

import { getParameterByName } from './function';
// import $ from 'jquery'
import con from './config';
const CONFIF: any = con;
declare var window: any

class User {
  openId() {
    const key = 'wechat_bind_openId2';
    return localStorage.getItem(key);
  }

  setOpenId(id: string) {
    const key = 'wechat_bind_openId2';
    localStorage.setItem(key, id);
  }

  avatar() {
    const key = 'wechat_bind_avatar2';
    return localStorage.getItem(key);
  }

  setAvatar(avatar: string) {
    const key = 'wechat_bind_avatar2';
    localStorage.setItem(key, avatar);
  }


  nickName() {
    const key = 'wechat_bind_name2';
    return localStorage.getItem(key);
  }

  setNickName(nickName: string) {
    const key = 'wechat_bind_name2';
    localStorage.setItem(key, nickName);
  }
  
  instId() {
    const key = 'wechat_bind_instId2';
    return localStorage.getItem(key);
  }

  setInstId(instId: string) {
    const key = 'wechat_bind_instId2';
    console.log(key);
    localStorage.setItem(key, instId);
  }

  loginIn() {
    const appId = window.CONFG.appId;
    const instId = getParameterByName('instId');
    console.log(instId);
    this.setInstId(instId);
    let redirectUri = location.origin + location.pathname;
    redirectUri = encodeURIComponent(redirectUri);
    let redirect = "";
    redirect = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${instId}#wechat_redirect`;
    window.location.href = redirect;
  }

}

export default new User();